import { ApiClient, ApiModelPortfolioUsage } from '@/api'
import { CheckboxAccordionItem } from '@/components/core-v2/molecules'

import { mapClientData } from '.'

export const getComparisonDatasets = (
  originalClients: ApiClient[],
  proposedClients: ApiClient[],
  originalPortfolioUsage: ApiModelPortfolioUsage,
  proposedPortfolioUsage: ApiModelPortfolioUsage,
  originalAllowedIds: string[],
  proposedAllowedIds: string[]
) => {
  // First create both datasets without highlighting
  const originalData = mapClientData(originalClients, originalPortfolioUsage, originalAllowedIds)

  const proposedData = mapClientData(proposedClients, proposedPortfolioUsage, proposedAllowedIds)

  // Create lookup maps for efficient comparison
  const createLookupMap = (data: CheckboxAccordionItem[]) => {
    const map = new Map<string, CheckboxAccordionItem>()
    const processItems = (items: CheckboxAccordionItem[]) => {
      items.forEach(item => {
        map.set(item.id, item)
        if (item.children) processItems(item.children)
      })
    }
    processItems(data)
    return map
  }

  const originalMap = createLookupMap(originalData)
  const proposedMap = createLookupMap(proposedData)

  // Compare and mark differences in both datasets
  const compareAndMark = (
    item: CheckboxAccordionItem,
    compareMap: Map<string, CheckboxAccordionItem>
  ): boolean => {
    const compareItem = compareMap.get(item.id)
    if (!compareItem) return false

    let hasDifference = false

    // Compare basic properties
    if (
      item.name !== compareItem.name ||
      item.value !== compareItem.value ||
      item.checked !== compareItem.checked
    ) {
      hasDifference = true
    }

    // Compare children count
    const itemChildren = item.children || []
    const compareChildren = compareItem.children || []
    if (itemChildren.length !== compareChildren.length) {
      hasDifference = true
    }

    // Recursively compare children
    if (item.children) {
      item.children.forEach(child => {
        if (compareAndMark(child, compareMap)) {
          hasDifference = true
        }
      })
    }

    // Mark if any differences found
    if (hasDifference) {
      item.highlighted = true
      compareItem.highlighted = true
    }

    return hasDifference
  }

  // Compare both directions
  originalData.forEach(item => compareAndMark(item, proposedMap))
  proposedData.forEach(item => compareAndMark(item, originalMap))

  return {
    originalData,
    proposedData
  }
}
